import Vue from 'vue';
import { Component, Prop, PropSync } from 'vue-property-decorator';
import RecipientFields from '@/components/common/RecipientFields.vue';

@Component({
    components: { RecipientFields },
})
export default class WriteReceiver extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @PropSync('value', { type: Object }) writeEmailData!: mail.WriteEmailData;
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    receiver: string = '';
    title: string = this.$t('W_Mail_Recipient').toString();

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    showWriteCC(show: boolean) {
        this.$emit('showWriteCC', show);
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        // 받는 사람
        for (let index = 0; index < this.writeEmailData.to.length; index++) {
            const element = this.writeEmailData.to[index];
            if (element.value != '') {
                this.receiver += element.value + ';';
            }
        }
    }
}
